/* ===== Vératex theme JS ===== */
(function(){
  "use strict";

  function $(s, c){ return (c||document).querySelector(s); }
  function $all(s, c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); }

  function toast(msg){
    var t = $("#toast"); if(!t) return;
    t.textContent = msg; t.classList.add("show");
    clearTimeout(t._timer);
    t._timer = setTimeout(function(){ t.classList.remove("show"); }, 2000);
  }
  window.vxToast = toast;

  /* ---- cart count ---- */
  function refreshCart(){
    fetch("/cart.js", { headers:{ "Accept":"application/json" } })
      .then(function(r){ return r.json(); })
      .then(function(c){
        $all(".bag-count").forEach(function(el){ el.textContent = c.item_count; });
      }).catch(function(){});
  }
  window.vxRefreshCart = refreshCart;

  /* ---- desktop dropdown ---- */
  var dd = $("#HeaderDropdown");
  if(dd){
    var ddBtn = $(".dd-btn", dd);
    if(ddBtn){
      ddBtn.addEventListener("click", function(e){ e.stopPropagation(); dd.classList.toggle("open"); });
      document.addEventListener("click", function(){ dd.classList.remove("open"); });
    }
  }

  /* ---- mobile menu ---- */
  var mnav = $("#MobileNav");
  function openMobile(){ if(mnav){ mnav.classList.add("open"); document.body.style.overflow="hidden"; } }
  function closeMobile(){ if(mnav){ mnav.classList.remove("open"); document.body.style.overflow=""; } }
  var burger = $("#Burger");
  if(burger) burger.addEventListener("click", openMobile);
  if(mnav){
    $all("[data-close-mobile]", mnav).forEach(function(el){ el.addEventListener("click", closeMobile); });
  }
  document.addEventListener("keydown", function(e){ if(e.key==="Escape"){ closeMobile(); if(dd) dd.classList.remove("open"); } });

  /* ---- cookie banner ---- */
  var cookie = $("#CookieBanner");
  if(cookie){
    var seen;
    try { seen = localStorage.getItem("vx_cookie_ok"); } catch(e){ seen = null; }
    if(!seen){ cookie.classList.remove("hide"); }
    $all("[data-cookie-dismiss]", cookie).forEach(function(b){
      b.addEventListener("click", function(){
        cookie.classList.add("hide");
        try { localStorage.setItem("vx_cookie_ok","1"); } catch(e){}
      });
    });
  }

  /* ---- quick add to cart (cards) ---- */
  $all("[data-quick-add]").forEach(function(btn){
    btn.addEventListener("click", function(e){
      e.preventDefault(); e.stopPropagation();
      var id = btn.getAttribute("data-variant-id");
      if(!id) return;
      btn.disabled = true; var old = btn.textContent; btn.textContent = "Adding…";
      fetch("/cart/add.js", {
        method:"POST", headers:{ "Content-Type":"application/json", "Accept":"application/json" },
        body: JSON.stringify({ id: id, quantity: 1 })
      }).then(function(r){ return r.json(); })
        .then(function(){ refreshCart(); toast("Added to bag"); })
        .catch(function(){ toast("Sorry, couldn't add that"); })
        .finally(function(){ btn.disabled = false; btn.textContent = old; });
    });
  });

  /* ---- product page gallery (arrows + swipe) ---- */
  var track = $("#GalTrack");
  if(track){
    var slides = $all(".gal-slide", track);
    var thumbs = $all("#GalThumbs img");
    function indexNow(){ return Math.round(track.scrollLeft / track.clientWidth); }
    function goTo(i){
      i = Math.max(0, Math.min(slides.length - 1, i));
      if(slides[i]) track.scrollTo({ left: slides[i].offsetLeft, behavior: "smooth" });
    }
    var prev = $("#GalPrev"), next = $("#GalNext");
    if(prev) prev.addEventListener("click", function(){ goTo(indexNow() - 1); });
    if(next) next.addEventListener("click", function(){ goTo(indexNow() + 1); });
    thumbs.forEach(function(t){
      t.addEventListener("click", function(){ goTo(parseInt(t.getAttribute("data-index"), 10) || 0); });
    });
    var st;
    track.addEventListener("scroll", function(){
      clearTimeout(st);
      st = setTimeout(function(){
        var idx = indexNow();
        thumbs.forEach(function(x, j){ x.classList.toggle("sel", j === idx); });
        if(prev) prev.style.opacity = idx === 0 ? "0.35" : "1";
        if(next) next.style.opacity = idx === slides.length - 1 ? "0.35" : "1";
      }, 70);
    });
  }

  /* ---- qty stepper ---- */
  $all("[data-qty]").forEach(function(box){
    var input = $("input", box);
    var minus = $("[data-qty-minus]", box);
    var plus  = $("[data-qty-plus]", box);
    var max = parseInt(input.getAttribute("max") || "9999", 10);
    if(minus) minus.addEventListener("click", function(){ var v=parseInt(input.value||"1",10); if(v>1){ input.value=v-1; input.dispatchEvent(new Event("change")); } });
    if(plus)  plus.addEventListener("click", function(){ var v=parseInt(input.value||"1",10); if(v<max){ input.value=v+1; input.dispatchEvent(new Event("change")); } });
  });

  /* ---- product add-to-cart button label reflects qty*price (handled server-side fallback) ---- */
  var pdpForm = $("#ProductForm");
  if(pdpForm){
    pdpForm.addEventListener("submit", function(e){
      // let Shopify handle non-JS; if JS, do AJAX add then toast
      if(window.fetch){
        e.preventDefault();
        var fd = new FormData(pdpForm);
        var btn = $(".add", pdpForm);
        if(btn){ btn.disabled = true; }
        fetch("/cart/add.js", { method:"POST", body: fd, headers:{ "Accept":"application/json" } })
          .then(function(r){ return r.json(); })
          .then(function(){ refreshCart(); toast("Added to bag"); })
          .catch(function(){ toast("Sorry, couldn't add that"); })
          .finally(function(){ if(btn) btn.disabled = false; });
      }
    });
  }

  /* ---- initial cart count sync ---- */
  refreshCart();
})();
